/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../packages/cognite-dashboard-core/src/routes/__root'
import { Route as NotificationsRouteImport } from './../packages/cognite-dashboard-core/src/routes/notifications'
import { Route as DashboardRouteImport } from './../packages/cognite-dashboard-core/src/routes/dashboard'
import { Route as BookmarksRouteImport } from './../packages/cognite-dashboard-core/src/routes/bookmarks'
import { Route as AiRouteImport } from './../packages/cognite-dashboard-core/src/routes/ai'
import { Route as IndexRouteImport } from './../packages/cognite-dashboard-core/src/routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as BookmarksIdRouteImport } from './../packages/cognite-dashboard-core/src/routes/bookmarks/$id'
import { Route as AiChatSessionIdRouteImport } from './../packages/cognite-dashboard-core/src/routes/ai/$chatSessionId'
import { Route as DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125RouteImport } from './routes/dashboard/overview.{-$field}.{-$reservoir}.{-$platform}.{-$well}'

const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const BookmarksRoute = BookmarksRouteImport.update({
  id: '/bookmarks',
  path: '/bookmarks',
  getParentRoute: () => rootRouteImport,
} as any)
const AiRoute = AiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const BookmarksIdRoute = BookmarksIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => BookmarksRoute,
} as any)
const AiChatSessionIdRoute = AiChatSessionIdRouteImport.update({
  id: '/$chatSessionId',
  path: '/$chatSessionId',
  getParentRoute: () => AiRoute,
} as any)
const DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route =
  DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125RouteImport.update(
    {
      id: '/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}',
      path: '/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}',
      getParentRoute: () => DashboardRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ai': typeof AiRouteWithChildren
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/ai/$chatSessionId': typeof AiChatSessionIdRoute
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}': typeof DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ai': typeof AiRouteWithChildren
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/ai/$chatSessionId': typeof AiChatSessionIdRoute
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}': typeof DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ai': typeof AiRouteWithChildren
  '/bookmarks': typeof BookmarksRouteWithChildren
  '/dashboard': typeof DashboardRouteWithChildren
  '/notifications': typeof NotificationsRoute
  '/ai/$chatSessionId': typeof AiChatSessionIdRoute
  '/bookmarks/$id': typeof BookmarksIdRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}': typeof DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ai'
    | '/bookmarks'
    | '/dashboard'
    | '/notifications'
    | '/ai/$chatSessionId'
    | '/bookmarks/$id'
    | '/dashboard/'
    | '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ai'
    | '/bookmarks'
    | '/notifications'
    | '/ai/$chatSessionId'
    | '/bookmarks/$id'
    | '/dashboard'
    | '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
  id:
    | '__root__'
    | '/'
    | '/ai'
    | '/bookmarks'
    | '/dashboard'
    | '/notifications'
    | '/ai/$chatSessionId'
    | '/bookmarks/$id'
    | '/dashboard/'
    | '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AiRoute: typeof AiRouteWithChildren
  BookmarksRoute: typeof BookmarksRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
  NotificationsRoute: typeof NotificationsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bookmarks': {
      id: '/bookmarks'
      path: '/bookmarks'
      fullPath: '/bookmarks'
      preLoaderRoute: typeof BookmarksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai': {
      id: '/ai'
      path: '/ai'
      fullPath: '/ai'
      preLoaderRoute: typeof AiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/bookmarks/$id': {
      id: '/bookmarks/$id'
      path: '/$id'
      fullPath: '/bookmarks/$id'
      preLoaderRoute: typeof BookmarksIdRouteImport
      parentRoute: typeof BookmarksRoute
    }
    '/ai/$chatSessionId': {
      id: '/ai/$chatSessionId'
      path: '/$chatSessionId'
      fullPath: '/ai/$chatSessionId'
      preLoaderRoute: typeof AiChatSessionIdRouteImport
      parentRoute: typeof AiRoute
    }
    '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}': {
      id: '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
      path: '/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
      fullPath: '/dashboard/overview/{-$field}/{-$reservoir}/{-$platform}/{-$well}'
      preLoaderRoute: typeof DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125RouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface AiRouteChildren {
  AiChatSessionIdRoute: typeof AiChatSessionIdRoute
}

const AiRouteChildren: AiRouteChildren = {
  AiChatSessionIdRoute: AiChatSessionIdRoute,
}

const AiRouteWithChildren = AiRoute._addFileChildren(AiRouteChildren)

interface BookmarksRouteChildren {
  BookmarksIdRoute: typeof BookmarksIdRoute
}

const BookmarksRouteChildren: BookmarksRouteChildren = {
  BookmarksIdRoute: BookmarksIdRoute,
}

const BookmarksRouteWithChildren = BookmarksRoute._addFileChildren(
  BookmarksRouteChildren,
)

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route: typeof DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route:
    DashboardOverviewDotChar123FieldChar125DotChar123ReservoirChar125DotChar123PlatformChar125DotChar123WellChar125Route,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AiRoute: AiRouteWithChildren,
  BookmarksRoute: BookmarksRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
  NotificationsRoute: NotificationsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
